import(/* webpackMode: "eager" */ "/vercel/path0/app/integration/page.tsx");
